import {HStack, Text} from 'platform/foundation';

import {MoneyText} from '@dms/features/new-vehicle';
import i18n from '@dms/i18n';

const INCLUDED_PRICE = '0.00';

/** A catalogue surcharge: "Included" when it costs nothing, otherwise "+ amount". */
export function PriceTag(props: {amount: string; currency: string; size?: 'small' | 'xSmall'}) {
  const size = props.size ?? 'small';
  if (props.amount === INCLUDED_PRICE) {
    return (
      <Text size={size} color="success" noWrap>
        {i18n.t('entity.newVehicle.labels.included', {defaultValue: 'Included'})}
      </Text>
    );
  }
  return (
    <HStack spacing={0} align="baseline">
      <Text size={size} color="secondary">
        +
      </Text>
      <MoneyText
        amount={props.amount}
        currency={props.currency}
        size={size}
        color="secondary"
        noWrap
      />
    </HStack>
  );
}
